import { ReportFormWrapper } from "../../../../pages/Reports/AddReport/addReport.styled";
import Select from "../../../shared/_FormInputs/Select";
import StampDropdownItem from "./StampDropdownItem";
import { mantineRenderOption } from "src/utils/mantineRenderOption";
import { useGetApi } from "../../../../hooks";
import { WDRLbid } from "../../../../pages/Settings/YachtSetup/ShipsStamps/ShipsStamp.utils";
import { useEffect } from "react";
import { getYachtId } from "../../../../utils";

interface Props {
  control: any;
  watch: (name: string) => any;
}
const ReportStampInputs = ({ control, watch }: Props) => {
  const logbook = watch("data.logbook");
  const stamp = watch("data.stamp");
  const type = watch("data.type");

  const { data: stamps, refetch: fetchStamps } = useGetApi({
    request: "get-stamps",
    mapper: (data: any) => {
      let filtered = data.list;

      if (logbook !== "*" || type === "1" || type === "3" || type === "4")
        filtered = data.list.filter((stamp: any) => {
          const parsed = JSON.parse(stamp.logbooks);
          return (
            (type !== "1" && type !== "3" && parsed.length === 0) ||
            parsed.includes("*") ||
            parsed.includes(logbook) ||
            (type === "1" && parsed.includes("L10")) ||
            (type === "3" && parsed.includes(WDRLbid)) ||
            (type === "4" && parsed.includes("crewListReport"))
          );
        });
      else if (logbook === "*" && type === "0")
        filtered = data.list.filter((stamp: any) => {
          const parsed = JSON.parse(stamp.logbooks);
          return (
            parsed.includes("*") ||
            (!parsed.includes(WDRLbid) &&
              !parsed.includes("L10") &&
              !parsed.includes("crewListReport"))
          );
        });

      return filtered.map((stamp: any) => ({
        value: stamp.stampid,
        label: stamp.name,
        image: stamp.data,
      }));
    },
    fetchOnInit: false,
  });
  useEffect(() => {
    if (logbook || type) {
      if (type === "6") return;
      void fetchStamps({ params: { yachtid: getYachtId() } });
    }
  }, [logbook, type]);

  return (
    <ReportFormWrapper>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Select
          control={control}
          name="data.stamp"
          maw={"550px"}
          miw={"300px"}
          label="Assigned Stamp"
          disabled={!stamps || stamps?.length === 0 || type === "6"}
          data={stamps ?? []}
          renderOption={mantineRenderOption(StampDropdownItem)}
        />
        <Select
          control={control}
          name="data.stampPlacement"
          maw={"550px"}
          miw={"300px"}
          label="Stamp Placement"
          disabled={!stamp}
          data={[
            {
              label: "PDF and Screen",
              value: "pdfAndScreen",
            },
            {
              label: "PDF only",
              value: "pdfOnly",
            },
            {
              label: "Screen only",
              value: "screenOnly",
            },
          ]}
        />
      </div>
    </ReportFormWrapper>
  );
};
export default ReportStampInputs;
